<template>
  <div
      :style="isPC
      ? 'padding: 9.375rem 2.5vw 1.5rem; overflow-x: hidden'
      : 'padding: 11.375rem 2.5vw 1.5rem; overflow-x: hidden'
    "
  >
    <div class="homework-box">
      <div class="search-box">
        <el-row type="flex" align="bottom" :gutter="20" style="flex-wrap: wrap">
          <el-col :xs="24" :sm="8" :md="8">
            <el-select @change="search" v-model="form.lang" clearable placeholder="全部版本 All" style="width: 100%" disabled>
              <el-option v-for="(item, index) in langList" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-select @change="search" v-model="form.objectType" clearable placeholder="全部模式 All" style="width: 100%">
              <el-option label="Mode/模式" value="0">Mode/模式</el-option>
              <el-option label="小測 Quiz" value="1">小測 Quiz</el-option>
              <el-option label="評估 Assessment" value="2">評估 Assessment</el-option>
              <el-option label="作業 Homework" value="3">作業 Homework</el-option>
            </el-select>
          </el-col>
          <el-col
              :lg="{ span: 7, offset: 1 }"
              :xs="24"
              :sm="8"
              style="display: flex; padding-top: 0.625rem"
          >
            <button
                @click="search"
                class="table-button"
                style="background-color: #fcc03a; margin-right: 0; flex: 1"
            >
              {{ $t("studentProgramme.search") }}
            </button>
          </el-col>
        </el-row>
      </div>
      <div class="summary-box">
        <!-- PC端表格展示 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            v-if="isPC"
            v-loading="tableLoading"
            element-loading-text="Loading..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.8)"
        >
          <el-table-column :label="$t('studentProgramme.mode')" min-width="80">
            <template slot-scope="{ row }">
              <span v-if="row.objectType==0">Mode/模式</span>
              <span v-if="row.objectType==1">小測 Quiz</span>
              <span v-if="row.objectType==2">評估 Assessment</span>
              <span v-if="row.objectType==3">作業 Homework</span>
            </template>
          </el-table-column>
          <el-table-column prop="topicName" :label="$t('studentProgramme.topicTitle')" min-width="100">
          </el-table-column>
          <el-table-column prop="objectName" :label="$t('studentProgramme.practiseName')" min-width="100">
          </el-table-column>
          <el-table-column
              prop="startTime"
              :label="$t('studentProgramme.startDate')"
              width="140"
              :formatter="myFormatter"
          >
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.duration')" min-width="80">
            <template slot-scope="scope">
              {{scope.row.answeringMinutes}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.scoreAndTotalScore')" min-width="60">
            <template slot-scope="scope">
              {{scope.row.correctQuantity+'/'+scope.row.score}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('studentProgramme.courseVersion')" min-width="80">
            <template slot-scope="scope">
              {{scope.row.lang==0?'香港數學課程':'Hong Kong Mathematics Curriculum'}}
            </template>
          </el-table-column>
          <el-table-column width="200" align="center">
            <template slot-scope="scope">
              <button
                  class="table-button"
                  @click="handleReview(scope.row)"
              >
                {{ $t("studentProgramme.review") }}
              </button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 移动端卡片展示 -->
        <div class="mobile-list" v-else>
          <div class="mobile-card" v-for="(row, index) in tableData" :key="index" v-loading="tableLoading">
            <!-- 卡片头部 - 模式 -->
            <div class="card-header">
              <span class="mode-tag">
                <span v-if="row.objectType==0">圖書館/冒險</span>
                <span v-if="row.objectType==1">小測</span>
                <span v-if="row.objectType==2">評估</span>
                <span v-if="row.objectType==3">作業</span>
              </span>
              <span class="lang-tag">
                {{row.lang==0?'香港數學課程':'HK Mathematics Curriculum'}}
              </span>
            </div>

            <!-- 卡片内容 -->
            <div class="card-body">
              <div class="info-item">
                <label>{{ $t("studentProgramme.topicTitle") }}：</label>
                <span>{{ row.topicName || '---' }}</span>
              </div>
              <div class="info-item">
                <label>{{ $t("studentProgramme.practiseName") }}：</label>
                <span>{{ row.objectName || '---' }}</span>
              </div>
              <div class="info-item">
                <label>{{ $t("studentProgramme.startDate") }}：</label>
                <span>{{ myFormatter(row) || '---' }}</span>
              </div>
              <div class="info-item">
                <label>{{ $t("studentProgramme.duration") }}：</label>
                <span>{{ row.answeringMinutes || '---' }} 分钟</span>
              </div>
              <div class="info-item">
                <label>{{ $t("studentProgramme.scoreAndTotalScore") }}：</label>
                <span>{{ row.correctQuantity + '/' + row.score }}</span>
              </div>
            </div>

            <!-- 卡片操作按钮 -->
            <div class="card-footer">
              <button class="mobile-btn" @click="handleReview(row)">
                {{ $t("studentProgramme.review") }}
              </button>
            </div>
          </div>
        </div>

        <!-- 分页组件 -->
        <Pagination
            v-show="total > 0"
            :small="!isPC"
            :total="total"
            :autoScroll="false"
            :page.sync="listQ._page"
            :limit.sync="listQ._limit"
            @pagination="getData"
            layout="pager"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getAnswerResults } from "@/api/answerResult";
import Pagination from "@/components/Pagination";
import { formatDateTime, formatDate2 } from "@/filters";
import { isPC } from "@/utils/is-rules.js";
import {getStudying} from "@/api/user";

export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Pagination },
  name: "home",
  data() {
    return {
      langList: ["香港數學課程","Hong Kong Mathematics Curriculum"],
      isPC: isPC(),
      total: 0,
      gradeId: null,
      form: {
        studentId: null,
        lang: 0,
        objectType: null,
        gradeId: null,
        startDate: null,
        endDate: null,
        keywords: null,
      },
      listQ: {
        _page: 1,
        _limit: 5,
      },
      tableData: [],
      tableLoading: false,
    };
  },
  watch: {
    "$store.getters.currentGradeId": {
      handler(v) {
        this.gradeId = v;
        this.getData();
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getData();
    this.gradeId = this.$store.getters.currentGradeId;

  },
  methods: {
    // 获取数据列表
    async getData() {
      this.tableLoading = true;
      const studying = await getStudying();
      this.form.lang = studying.data;
      let form = {
        studentId: this.form.studentId,
        objectType: this.form.objectType,
        gradeId: this.form.gradeId || this.gradeId,
        lang: this.form.lang,
        startDate: formatDate2(this.form.startDate),
        endDate: formatDate2(this.form.endDate),
        keywords: this.form.keywords,
        _page: this.listQ._page - 1,
        _limit: this.listQ._limit,
      };

      getAnswerResults(form).then((v) => {
        this.tableLoading = false;
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 日期格式化
    myFormatter(row) {
      return row.startTime ? formatDateTime(new Date(row.startTime), 'dd/MM/yyyy HH:mm') : '';
    },
    // 搜索
    search() {
      this.listQ._page = 1; // 搜索重置页码
      this.getData();
    },
    // 清空搜索（保留方法，避免调用报错）
    clearSearch() {
      this.form = {
        studentId: null,
        lang: 0,
        objectType: null,
        gradeId: null,
        startDate: null,
        endDate: null,
        keywords: null,
      };
      this.listQ._page = 1;
      this.getData();
    },
    // 查看结果跳转（抽离方法，避免模板语法错误）
    handleReview(row) {
      this.$router.push({
        path: '/examinationAnswerResult',
        query: {
          type: 'library',
          objectName: row.objectName,
          topicId: row.topicId,
          objectType: row.objectType,
          id: row.objectId,
          gradeId: this.gradeId,
          answerResultId: row.id,
          questionListIds: row.questionListIds,
          answerValues: row.answerValues,
        },
      });
    },
    // 保留原有方法（避免调用报错）
    needHomework(row) {
      if (row.completedAt) return false;
      else if (row.startDate && row.endDate)
        return this.$options.filters["isBetween2"](
            new Date(),
            row.startDate,
            row.endDate
        );
      return false; // 修复原代码缺少return的问题
    },
  },
};
</script>

<style lang="scss" scoped>
// 定义响应式断点
$minWidth: 768px;
$maxWidth: 991px;
$phoneMinWidth: 320px;
$phoneMaxWidth: 767px;

.homework-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 6.25vw;
  background: #ffffff;
  border-radius: 2.5rem;
}
.input-title {
  color: #8e8e8e;
  font-weight: 500;
  line-height: 1.6rem;
  font-family: "GenSenRoundedJP", "Helvetica", "Arial";
}
.search-box {
  font-size: 0.875rem;
  width: 100%;
  margin-bottom: 1rem;
}
.summary-box {
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

// PC端表格按钮样式
.table-button {
  background: #fcc03a;
  box-shadow: 0px 0.5rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1.5rem;
  line-height: 2rem;
  display: block;
  margin: 0 auto 0.5rem;
  padding: 0.5rem 2rem;
  cursor: pointer;
}

// 移动端卡片样式
.mobile-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 1.5rem;
}
.mobile-card {
  background: #fff;
  border-radius: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f5f5f5;
  overflow: hidden;
}
.card-header {
  background: #fceedd;
  padding: 0.8rem 1.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;

  .mode-tag {
    background: #fcc03a;
    color: #444;
    padding: 0.2rem 0.8rem;
    border-radius: 1rem;
    font-size: 0.85rem;
    font-weight: 600;
  }

  .lang-tag {
    color: #666;
    font-size: 0.8rem;
  }
}
.card-body {
  padding: 1rem 1.2rem;

  .info-item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.75rem;
    font-size: 0.9rem;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      color: #8e8e8e;
      min-width: 70px;
      flex-shrink: 0;
      margin-right: 0.5rem;
    }

    span {
      color: #444;
      flex: 1;
      word-break: break-all;
    }
  }
}
.card-footer {
  padding: 0.8rem 1.2rem;
  border-top: 1px solid #f5f5f5;
  display: flex;
  justify-content: center;
}
.mobile-btn {
  background: #fcc03a;
  box-shadow: 0px 0.3rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1rem;
  padding: 0.5rem 2rem;
  color: #444;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
}

// 无数据提示
.empty-tip {
  text-align: center;
  padding: 3rem 0;
  color: #999;
  font-size: 1rem;
  width: 100%;
}

// 平板适配
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .homework-box {
    padding: 1.5rem 6.25vw;
  }
  .summary-box {
    margin-top: 1.5rem;
  }
  .table-button {
    font-size: 1.25rem;
    line-height: 1.5rem;
    padding: 0.375rem 1.5rem;
  }
}

// 手机适配
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .homework-box {
    padding: 1.5rem 4vw;
  }
  .summary-box {
    margin-top: 1rem;
  }
  .table-button {
    font-size: 1rem;
    line-height: 1.5rem;
    padding: 0.375rem 1.5rem;
    width: 100%;
  }
  // 移动端筛选栏适配
  .search-box {
    .el-col {
      margin-bottom: 0.8rem;
    }
  }
}

::v-deep {
  // 表格样式
  .el-table {
    font-size: 1rem;
  }
  .el-table .cell {
    padding: 0;
    line-height: 3.5rem;
  }
  .el-table th.el-table__cell > .cell {
    padding: 0;
  }
  .el-table th {
    background: #fceedd;
    color: #444444;
  }
  .el-table th:first-child {
    padding-left: 1rem;
  }
  .el-table td:first-child {
    padding-left: 1rem;
  }

  // 下拉选择框样式
  .el-select .el-input .el-select__caret {
    color: #b62d2e;
  }
  .el-input__inner {
    border-radius: 0.625rem;
    border: 0.0625rem solid #8e8e8e;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
}
</style>